import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    // Detect language from localStorage or navigator
    const lang = (() => {
      try { return localStorage.getItem('cvLanguage') || 'fr'; } catch { return 'fr'; }
    })();
    const isEn = lang === 'en';

    return (
      <div
        style={{
          minHeight: '100vh',
          backgroundColor: '#081B19',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: '400px' }}>
          <img
            src="/favicon-edomatch.png"
            alt="EdoMatch"
            style={{ width: 64, height: 64, margin: '0 auto 16px' }}
          />
          <h1 style={{ color: '#fff', fontSize: '1.5rem', fontWeight: 700, marginBottom: 8 }}>
            {isEn ? 'Oops! Something went wrong' : 'Oups ! Quelque chose s\'est mal passé'}
          </h1>
          <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginBottom: 24 }}>
            {isEn
              ? 'An unexpected error occurred. Please reload the page.'
              : 'Une erreur inattendue s\'est produite. Veuillez recharger la page.'}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: '#5BA946',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              padding: '12px 32px',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {isEn ? 'Reload' : 'Recharger'}
          </button>
        </div>
      </div>
    );
  }
}
